/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".coupon-card-modal__header[_ngcontent-%COMP%]{min-height:80px}.coupon-card-modal__header[_ngcontent-%COMP%]:after{display:none}.coupon-card-modal__header__icon[_ngcontent-%COMP%]{display:block;margin:22px auto 0;height:36px}.coupon-card-modal__header__close[_ngcontent-%COMP%]{--top:22px}"];
export { styles as styles };
